import React, { useEffect, useState } from "react";
import { addBgOnIframe } from "@revbox/helpers-fe";
import AdvertiserAnalytics from "../../adv/campaign/CampaignAnalytics";
import { mixpanelInstance } from "../../mixpanel/instance";
import '../loader.css';

export default function CustomerIframe() {
  // get inventory id and campaing id from url
  const [iframe, setIframe] = useState(null);

  useEffect(() => {
    mixpanelInstance.track("Customer Analytics Page Loaded");
    setIframe(1);
    addBgOnIframe();
  }, []);

  if (iframe === 1) {
    return (
      <AdvertiserAnalytics isIframe={true} />
    )
  } else {
    return (
      <div>
        <span className="loader"></span>
      </div>
    )
  }
}